import { render, staticRenderFns } from "./ManagerNewsView.vue?vue&type=template&id=6a72ecf6&scoped=true"
import script from "./ManagerNewsView.vue?vue&type=script&lang=js"
export * from "./ManagerNewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72ecf6",
  null
  
)

export default component.exports